import { render, staticRenderFns } from "./ParkingSpaceListItem.vue?vue&type=template&id=56afed5e&scoped=true&"
import script from "./ParkingSpaceListItem.vue?vue&type=script&lang=js&"
export * from "./ParkingSpaceListItem.vue?vue&type=script&lang=js&"
import style0 from "./ParkingSpaceListItem.vue?vue&type=style&index=0&id=56afed5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afed5e",
  null
  
)

export default component.exports